import { useCallback } from "react";

import useClient from "hooks/useClient";

const useDownloadServiceEstimatePdf = (): {
  download: (optionId: string, serviceId: string, estimateId: string) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const download = useCallback(
    async (optionId: string, serviceId: string, estimateId: string) => {
      const { data } = await client<Attachment, unknown>({
        method: "get",
        url: `/option/${optionId}/request-service/${serviceId}/estimate/${estimateId}/download-pdf`,
      });
      return data;
    },
    [client]
  );

  return { download };
};

export default useDownloadServiceEstimatePdf;
